import CitiesController from "./controllers/cities-controller";

export const showCitiesPopup = (logoData) => {
  new CitiesController({logoData}).show();
};
